import { ID } from './StandartId';

export const BREADCRUMB = {
  HEADER: ID.BREADCRUMB + "header",
};
